var map = {
	"./Blender_logo_no_text.svg.png": 6331,
	"./Css.png": 9936,
	"./Html3d.webp": 5691,
	"./JavaSc.webp": 5599,
	"./Nextlog.png": 5918,
	"./React.jpeg": 6249,
	"./Tailwind.png": 3869,
	"./bootlog.webp": 6241,
	"./download.jpg": 7605,
	"./framer.png": 2642,
	"./gsaplog.svg": 8324,
	"./unity-logo-988A22E703-seeklogo.com.png": 5609
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8073;